// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // webApiUrl: 'https://44.202.163.44:45455',
  webApiUrl: 'https://dev-api2.dibitnow.com',
  webApiVersion: '1',
  googleAnalyticsId: 'UA-74393458-6',
  platformId: 2,
  cottonBowlEventId: -1,
  orangeBowlEventId: -1,
  fiestaBowlEventId: -1,
  playoffSemifinalEventId: -1,
  peachBowlEventId: -1,
  sugarBowlEventId: -1,
  roseBowlEventId: -1,
  homeEventId: 55
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts